<template>
  <Modal title="加减课时" v-model="visible">
    <Form ref="classHourForm" class="form" :label-width="80"
      :model="classHourParam" :rules="classHourRule" >
      <Row>
        <Col :span="12">
          <Form-item :label-width="100" label="学生id" prop="uid" v-if="showUid">
            <Input v-model.number="classHourParam.uid" placeholder="请输入学生id"></Input>
          </Form-item>
        </Col>
        <Col :span="10">
          <Form-item label="课程类别" prop="class">
            <Select v-model.number="classHourParam.courseType" placeholder="请选择" transfer>
              <Option v-for="item in $constant.newCourseType"
                :value="item.code" :key="item.code">{{ item.text }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :span="12">
        <Form-item :label-width="100" label="加减课时数量" prop="num">
          <Input v-model.number="classHourParam.num" placeholder="请输入课时数"></Input>
        </Form-item>
        </Col>
        <Col :span="10">
        <Form-item :label-width="80" label="赠课类型" prop="givingType">
          <Select v-model.number="classHourParam.givingType" placeholder="请选择类型" @on-change="changeGivingType" clearable>
            <Option v-for="item in $constant.givingType"
                    :value="item.code" :key="item.code">{{ item.text }}</Option>
          </Select>
        </Form-item>
        </Col>
        <Col :span="12">
        <Form-item v-if="classHourParam.givingType === 2 || classHourParam.givingType === 3
                  || classHourParam.givingType === 5 || classHourParam.givingType === 6 || classHourParam.givingType === 7"
                   label="子类型" prop="givingTypeChild">
          <Select v-model.number="classHourParam.givingTypeChild" placeholder="全部" clearable>
            <Option v-for="item in givingTypeChild"
                    :value="item.code" :key="item.code">{{ item.text }}</Option>
          </Select>
        </Form-item>
        </Col>
        <Col :span="12">
          <FormItem label="被推荐人" v-if="classHourParam.givingType === 2" required>
            <Input v-model="classHourParam.inviteUid" placeholder="学生ID"></Input>
          </FormItem>
        </Col>
        <Col :span="22" v-if="classHourParam.givingType === 1 || classHourParam.givingType === 2 || classHourParam.givingType === 4 || classHourParam.givingType === 6 || classHourParam.givingType === 7 || classHourParam.givingType === 11">
          <Form-item label="上传凭证" prop="url">
            <multiple-image-upload :num="100" :defaultFileList="defaultPicList" v-model="classHourParam.url" on-file-change="onFileChange"/>
          </Form-item>
        </Col>
        <Col :span="12" v-if="classHourParam.givingType === 4 || classHourParam.givingType === 5 || classHourParam.givingType === 6">
          <Form-item :label-width="60" label="老师" prop="tchId">
            <TeacherSelect :category="[1, 2]" v-model.number="classHourParam.tchId" style="width: 143px"></TeacherSelect>
          </Form-item>
        </Col>
        <Col :span="12" v-if="classHourParam.givingType === 4">
          <Form-item :label-width="60" label="上课时间" prop="classTime" required>
            <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择日期"
                         @on-change="classTimeDateChange"
                         :value="classHourParam.classTime"></Date-picker>
          </Form-item>
        </Col>
        <Col :span="22">
          <Form-item label="原因" prop="reason">
            <Input type="textarea" :autosize="{minRows: 2,maxRows: 3}" :maxlength="100"
              placeholder="长度不要超过100个字符"
              v-model="classHourParam.reason" ></Input>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible=false">取消</Button>
      <Button type="primary" size="large" :loading="loadingUpdate" @click="update">保存</Button>
    </div>
  </Modal>
</template>
<script>
  export default {
    name: 'UserClassHourModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      uid: {
        type: Number
      },
      successCallback: {
        type: Function
      },
      courseType: {
        type: Number,
        default: 1
      },
      showUid:{
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        visible: this.value,
        loadingUpdate: false,
        defaultPicList: [],
        givingTypeChild: [],
        classHourParam: {
          courseType: this.courseType,
          num: '',
          reason: '',
          givingType: '',
          givingTypeChild: '',
          tchId: null,
          url: '',
          uid: '',
          classTime: '',
          inviteUid: ''
        },
        classHourRule: {
          num: [
            { type: 'integer', required: true, message: '请输入数量', trigger: 'blur' },
            { validator (rule, value, callback, source, options) {
              let errors = []
              if (value === 0) {
                errors.push('数量不能为0')
                callback(errors)
                return
              }
              callback(errors)
            } },
          ],
          url: [
            { type: 'string', required: true, message: '凭证图片不能为空', trigger: 'blur' }
          ],
          givingType: [
            { type: 'integer', required: true, message: '请选择类型', trigger: 'blur' },
          ],
          givingTypeChild: [
            { type: 'integer', required: true, message: '请选择子类型', trigger: 'blur' },
          ],
          reason: [
            { required: true, message: '请输入原因', trigger: 'blur' },
            { type: 'string', max: 100, message: '长度不要超过100个字符', trigger: 'blur' }
          ],
          tchId: [
            { type: 'integer', required: true, message: '请选择老师', trigger: 'blur' },
          ]
        }
      }
    },
    methods: {
      classTimeDateChange(value){
        this.classHourParam.classTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
      },
      onFileChange (fileList) {
        this.defaultPicList = fileList
      },
      update () {
        let self = this
        self.loadingUpdate = true
        self.$refs.classHourForm.validate((valid) => {
          if (!valid) {
            self.$Message.warning('信息输入错误!')
            self.loadingUpdate = false
            return
          }
          if (self.uid){
            self.classHourParam.uid = self.uid
          }
          self.validateShuang11Gift().then(function (ok) {
            if (!ok) {
              self.loadingUpdate = false
              return
            }
            self.$http.post('/bookCourseChange/add', self.classHourParam).then(function (res) {
              self.loadingUpdate = false
              if (res) {
                self.visible = false
                self.$Message.success('提交申请加减课时成功!')
              }
            }).catch(function () {
              self.loadingUpdate = false
            })
          }).catch(function () {
            self.loadingUpdate = false
          })
        })
      },
      /** 双十一赠课：前端节数校验（后端仍做权威校验） */
      validateShuang11Gift () {
        let self = this
        let reason = (self.classHourParam.reason || '')
        let num = self.classHourParam.num
        if (reason.indexOf('双十一') < 0 || !(num > 0)) {
          return Promise.resolve(true)
        }
        if (num !== 2 && num !== 4) {
          self.$Message.warning('双十一赠课节数只能是 2 或 4 节')
          return Promise.resolve(false)
        }
        let uid = self.classHourParam.uid || self.uid
        if (!uid) {
          self.$Message.warning('请填写学生id')
          return Promise.resolve(false)
        }
        return self.$http.get('/fundPackage/list', {
          params: { uid: uid, pageSize: 100, state: 1 }
        }).then(function (res) {
          let list = (res && (res.data || res.list || res)) || []
          if (!Array.isArray(list)) {
            list = (list.data || list.list || []) || []
          }
          function pickLatest (channels) {
            return list.filter(function (row) {
              return row && Number(row.state) === 1 && channels.indexOf(Number(row.channel)) >= 0
            }).sort(function (a, b) {
              return (Number(b.createTime) || 0) - (Number(a.createTime) || 0)
            })[0]
          }
          // 与后端一致：优先新签/结课新签，没有再认转介绍/转介绍补升
          let order = pickLatest([0, 5]) || pickLatest([1, 7])
          if (!order) {
            // 列表权限可能看不到他人订单，节数已限 2/4，交给后端权威校验
            return true
          }
          let pkgNum = Number(order.num)
          let expected = null
          if (pkgNum === 50) expected = 2
          else if ([72, 110, 144, 210].indexOf(pkgNum) >= 0) expected = 4
          if (expected == null) {
            self.$Message.warning('当前套餐（' + pkgNum + '节）不支持双十一赠课')
            return false
          }
          if (num !== expected) {
            self.$Message.warning('双十一赠课节数应为' + expected + '节（当前套餐' + pkgNum + '节）')
            return false
          }
          return true
        }).catch(function () {
          // 拉单失败不挡提交，后端会再校验
          return true
        })
      },
      changeGivingType (val) {
        let self = this
        if (val === 1) {
          self.givingTypeChild = []
        } else if (val === 2) {
          self.givingTypeChild = [{ code: 10, text: '转介绍成功购课' }, { code: 11, text: '邀请好友试听成功' }]
        } else if (val === 3) {
          self.givingTypeChild = [{ code: 8, text: '特殊请假' }, { code: 9, text: '家长态度强硬非要返还课时' }]
        } else if (val === 4) {
          self.givingTypeChild = []
        } else if (val === 5) {
          self.givingTypeChild = [{ code: 1, text: '课件编辑错' }]
        } else if (val === 6) {
          self.givingTypeChild = [{ code: 2, text: '老师离职' }, { code: 3, text: '老师旷课' }, { code: 4, text: '老师迟到10分钟以及以上' }, { code: 5, text: '老师网络原因不能上课' }]
        } else if (val === 7) {
          self.givingTypeChild = [{ code: 6, text: '教材不顺延' }, { code: 7, text: '课件排错' }]
        } else if (val === 8) {
          self.givingTypeChild = []
        } else if (val === 9) {
          self.givingTypeChild = []
        }
      }
    },
    watch: {
      value (val) {
        this.visible = val
      },
      visible (val) {
        let courseType = this.courseType
        this.classHourParam = {
          courseType: courseType,
          num: '',
          reason: '',
          url: ''
        }
        this.$emit('input', val)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// UserClassHourModal.vue?010665f1